import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';
import {
   createInterpolatedTranslationKey,
   dateTimeMinuteFormatter,
   patientNameFormatter,
   practitionerNameFormatter,
   Translate,
   useTranslate,
} from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';
import { ConfidentialResourceAccessRequestSingle } from '../../ResourceTypeCell.types';

import { RevokeAccessConfirmButton } from './RevokeAccessConfirmButton';

type RevokeAccessModalProps = {
   request: ConfidentialResourceAccessRequestSingle;
   onClose: VoidFunction;
};

export const RevokeAccessModal = (props: RevokeAccessModalProps): ReactElement => {
   const { request, onClose } = props;
   const translate = useTranslate();

   const [confidentialResource] = request.confidentialResources;
   const resourceTypeLabel = translate(systemActivityTranslationKeys.resourceTypeMap[request.resourceType]);
   const dataCategory = [
      resourceTypeLabel,
      dateTimeMinuteFormatter(confidentialResource.creationDate),
      patientNameFormatter(request.patient),
   ].join(', ');

   return (
      <Modal testId={'revokeAccess'} title={systemActivityTranslationKeys.revokeAccessTitle} width={ModalWidth.NORMAL}>
         <Translate>
            {createInterpolatedTranslationKey(systemActivityTranslationKeys.revokeAccessConfirmation, {
               practitionerName: practitionerNameFormatter(request.grantee),
               dataCategory: dataCategory,
            })}
         </Translate>
         <RevokeAccessConfirmButton requestId={request.id} grantee={request.grantee} onSuccess={onClose} />
         <ModalCancelButton onClick={onClose} />
         <ModalCloseButton onClick={onClose} />
      </Modal>
   );
};
